const CONST = {
    SYMBOLS: {
        WILD: "8"
    },
    COLUMNS: 5,
    ROWS: 4
}

export { CONST }
